module.exports = __webpack_public_path__ + "img/logo.f064afe5.png";